<template>
    <div>
        <transition name="fade">
        <loader v-if="loading"></loader>
        </transition>
        <header-comp></header-comp>
        <transition name="fade" mode="out-in">
        <router-view @updateLoader="updateLoader"></router-view>
        </transition>
        <footer-comp></footer-comp>
    </div>
</template>
<script>
    import HeaderComp from '../components/Header';
    import FooterComp from '../components/Footer';
    import Loader from '../components/Loader';
    export default {
        components: {
            HeaderComp,
            FooterComp,
            Loader
        },
        data() {
            return {
                loading: true
            }
        },
        methods: {
            updateLoader(status) {
                this.loading = status;
            }
        },
        watch: {
            $route: {
                immediate: true,
                handler(to, from) {
                    this.loading = true;
                }
            },
        },
    }
</script>